import { useEffect, useState } from 'react';

// Ticks every `ms` while `active`, starting after `offset` so several
// tickers on one page don't all fire together.
export function useRotation(length, { ms, offset = 0, active }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active || length < 2) return undefined;
    let interval;
    const start = setTimeout(() => {
      setIndex((i) => (i + 1) % length);
      interval = setInterval(() => setIndex((i) => (i + 1) % length), ms);
    }, offset || ms);
    return () => { clearTimeout(start); clearInterval(interval); };
  }, [active, length, ms, offset]);

  return index;
}

export function usePrefersReducedMotion() {
  const query = '(prefers-reduced-motion: reduce)';
  const [reduced, setReduced] = useState(() => typeof window !== 'undefined' && window.matchMedia?.(query).matches);

  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return undefined;
    const onChange = (e) => setReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
